import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";

import AppLayout from "../../components/layout/AppLayout";
import Breadcrumb from "../../components/layout/Breadcrumb";
import CuttingReceiveForm from "../../components/cuttingReceives/CuttingReceiveForm";
import { pageTitleClass } from "../../components/ui/styles";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  clearCuttingReceiveOpenOrders,
  fetchCuttingReceiveOpenOrders,
  fetchCuttingReceiveParties,
  getCuttingReceiveOpenOrders,
  getCuttingReceiveOpenOrdersLoading,
  getCuttingReceivePartyOptions,
} from "../../features/cuttingReceives/cuttingReceivesSlice";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import { POST } from "../../services/axios.service";
import { receiveLinePayload } from "../../static/cuttingLine";
import { hasPermission, permission } from "../../static/permission";
import { route } from "../../static/route";
import { toastStyles } from "../../static/styles";
import { BreadcrumbType } from "../../types/common";
import { ICuttingReceiveFormInput } from "../../types/cuttingReceive";

const breadcrumbItems: BreadcrumbType[] = [
  { label: "હોમ", href: route.dashboard },
  { label: "કટીંગ રિસીવ", href: route.cuttingReceives },
  { label: "નવી રિસીવ" },
];

const CuttingReceiveCreatePage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const partyOptions = useAppSelector(getCuttingReceivePartyOptions);
  const openOrders = useAppSelector(getCuttingReceiveOpenOrders);
  const openOrdersLoading = useAppSelector(getCuttingReceiveOpenOrdersLoading);
  const loggingUser = useAppSelector(getLoggingUser);

  const withRates = hasPermission(
    loggingUser?.permissions,
    permission.cuttingRate
  );

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(fetchCuttingReceiveParties());
    dispatch(clearCuttingReceiveOpenOrders());
  }, [dispatch]);

  const handlePartyChange = useCallback(
    (partyId: number) => {
      if (partyId) {
        dispatch(fetchCuttingReceiveOpenOrders({ party_id: partyId }));
      } else {
        dispatch(clearCuttingReceiveOpenOrders());
      }
    },
    [dispatch]
  );

  const handleSubmit = async (data: ICuttingReceiveFormInput) => {
    setIsSubmitting(true);
    try {
      await POST("/v1/admin/cutting-receives", {
        party_id: data.party_id,
        date: moment(data.date).format("YYYY-MM-DD HH:mm:ss"),
        items: receiveLinePayload(data.items, withRates),
      })
        .then((response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
            navigate(route.cuttingReceives);
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppLayout>
      <div className="mb-2 md:mb-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex items-center mb-4 md:mb-6 mt-2">
        <h1 className={pageTitleClass}>નવી કટીંગ રિસીવ ઉમેરો</h1>
      </div>

      <div className="flex flex-col gap-6">
        <CuttingReceiveForm
          partyOptions={partyOptions}
          openOrders={openOrders}
          openOrdersLoading={openOrdersLoading}
          onPartyChange={handlePartyChange}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onCancel={() => navigate(route.cuttingReceives)}
          submitLabel="સાચવો"
          withRates={withRates}
        />
      </div>
    </AppLayout>
  );
};
export default CuttingReceiveCreatePage;
